import React, { useEffect } from 'react'
import { Button, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { listComments, deleteComment } from '../actions/mediaActions'
import { Helmet } from 'react-helmet-async'

function CommentListScreen({ history }) {

  const dispatch = useDispatch()

  const commentListAll = useSelector(state => state.commentListAll)
  const { loading, error, comments } = commentListAll

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const commentDelete = useSelector(state => state.commentDelete)
  const { success: successDelete } = commentDelete

  useEffect(() => {
    if (userInfo && userInfo.isAdmin) {
      dispatch(listComments())
    } else {
      history.push('/login')
    }
  }, [dispatch, history, successDelete, userInfo])

  const deleteHandler = (id) => {
    if (window.confirm('Sei sicuro di voler eliminare questo commento?')) {
      dispatch(deleteComment(id))
    }
  }

  return (
    <div>
      <Helmet>
         <meta name="robots" content="noindex, follow" />
       </Helmet>
      <h1>Commenti</h1>

      {loading ? <Loader />
        : error ? <Message variant='danger'>{error}</Message>
        :
        <Table striped bordered hover responsive className='table-sm'>
          <thead>
            <tr>
              <th>Utente</th>
              <th>Contenuto</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {comments.map(comment => (
              <tr key={comment._id}>
                <td>{comment.user}</td>
                <td>
                  {comment.comment && comment.comment.length > 80
                    ? comment.comment.slice(0, 80) + '…'
                    : comment.comment}
                </td>
                <td>
                  <Button variant='danger' className='btn-sm' onClick={() => deleteHandler(comment._id)}>
                    <i className='fas fa-trash'></i> Elimina
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      }
    </div>
  )
}

export default CommentListScreen